<template>
  <div class="GoodCode">
    <div class="page-title">{{$t('title.good')}}</div>        
    <div>
      <ATable
        ref="table"
        hideButtonExcel
        hide-button-insert
        hide-pagination
        :placeholder="placeHolder"
        :search_field="search_field"
        :data="items"
        :loading="loading"
        border
        max-height="732px"  
        highlight-current-row        
      >
        <div slot="search">
          <div class="inline">
            <APeriodSelector 
              ref="period" 
              :value="search_period" 
              hide-select
              @change="handleChangePeriod" 
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
        </div>
        <el-table-column
          type="index"
          :label="$t('lang.No')"
          align="center"
          :width="$width.index"
        />
        <el-table-column prop="code" 
          :label="$t('lang.serial')" 
          width="200" 
          sortable />
        <el-table-column prop="product_name" 
          :label="$t('lang.product_name')" 
          sortable />
        <el-table-column prop="size" 
          :label="$t('lang.size')" 
          width="150" 
          sortable />
        <el-table-column prop="customer_name"
          :label="$t('lang.customer_name')" 
          width="200" 
          sortable />        
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />        
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>   
  </div>
</template>

<script>

export default {
  name: "Code",
  mixins: [],
  components: {},
  data() {
    return {
      items: [],      
      loading: false,      
      placeHolder: "품번, 품목, 규격, 거래처",
      search_field: ["code", "product_name", "size", "customer_name"],
      search_period: {value: '1m'},
      period: {},
    };
  },
  computed: {},
  created() {},
  methods: {        
    loadData() {
      this.loading = true;
      this.api.listGoodCode(this.period).then(res => {        
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
        }
        this.items = res.data;
      });      
    },
    handleChangePeriod(value) {
      this.period = value;
      this.handleClickSearch();
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },    
  }
};
</script>